import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject as Projects } from 'api/models'

export interface CatalogState {
  catalog: Projects[]
  genres: { value: string; title: string }[][]
  total: number
  loading: boolean
  error: null | string
}
export enum CatalogActionTypes {
  FETCH_CATALOG = 'FETCH_CATALOG',
  FETCH_CATALOG_SUCCESS = 'FETCH_CATALOG_SUCCESS',
  FETCH_CATALOG_SUCCESS_MORE = 'FETCH_CATALOG_SUCCESS_MORE',
  FETCH_CATALOG_ERROR = 'FETCH_CATALOG_ERROR',
}
interface FetchCatalogAction {
  type: CatalogActionTypes.FETCH_CATALOG
}
interface FetchCatalogSuccessAction {
  type:
    | CatalogActionTypes.FETCH_CATALOG_SUCCESS
    | CatalogActionTypes.FETCH_CATALOG_SUCCESS_MORE
  payload: { items: Projects[]; total: number; genres: number[] }
}
interface FetchCatalogErrorAction {
  type: CatalogActionTypes.FETCH_CATALOG_ERROR
  payload: string
}
export type CatalogAction =
  | FetchCatalogAction
  | FetchCatalogErrorAction
  | FetchCatalogSuccessAction
